import { Avatar, Menu, Select, Text } from "@mantine/core";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { getDepartmentText, mapRoleToLabel } from "./utilities";
import { IconDoorExit, IconExchange } from "@tabler/icons-react";
import {
  changeBusinessUnit,
  changeDepartment,
  changeUserRole,
  getBuData,
} from "../apis/userApis";
import {
  deleteCookie,
  getCookiesSession,
  setCookiesSession,
} from "../apis/cookiesSession";
const AppHeader = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userData = JSON.parse(getCookiesSession("userData"));
  const [opened, setOpened] = useState(true);
  const [buData, setBuData] = useState([]);
  useEffect(() => {
    const getBuLabelData = async () => {
      const response = await getBuData();
      setBuData(response.formattedResponse);
    };

    getBuLabelData();
  }, []);
  const logoutHandler = () => {
    if (getCookiesSession("userData")) {
      deleteCookie("userData");
    }
    if (getCookiesSession("token")) {
      deleteCookie("token");
    }
    if (getCookiesSession("LawSignaUserData")) {
      deleteCookie("LawSignaUserData");
    }
    navigate("/login", { replace: true });
  };
  function getLabelByValue(value) {
    const result = buData.find((item) => item.value === value);
    return result ? result.label : "Not Found";
  }
  return (
    <div className="flex flex-row justify-between mx-8 my-0">
       <div className="flex items-center gap-2">
        <img
          style={{ width: "8rem" }}
          src="https://mswordapp.lawsigna.com/assets/images/SecondaryLogo.png"
          alt="LawSigna Logo"
        />

        <div
          style={{
            padding: "3px 10px",
            borderRadius: "999px",
            border: "1px solid #d1d5db",
            backgroundColor: "#edeeef",
            fontSize: "0.80rem",
            fontWeight: 600,
            fontFamily: "Cinzel",
          }}
        >
          Obligations Hub
        </div>
      </div>
      <div className="flex">
        {/* <Select
          required
          className="max-w-lg mr-2"
          placeholder="Select Role to login as"
          data={roles.map((role) => ({
            label: role.name,
            value: role.id,
            pass: role,
          }))}
          // label={currentUser.loginAs.name}
          value={currentUser.loginAs.id}
          onChange={(pass) => handleRoleChange(pass)}
        /> */}
        {/* <Select
          className="flex items-center cursor-pointer mr-4"
          value={userData.businessUnit}
          data={userData.businessUnits.split(",").map((bu) => ({
            value: parseInt(bu),
            label: getLabelByValue(bu),
          }))}
          // data={userData.role.split(",")}
          onChange={async (val) => {
            const response = await changeBusinessUnit({buId: val });
            if (response.success) {
              const user = { ...response.user };
              localStorage.setItem("userData", JSON.stringify(user));
              localStorage.setItem("token", response.token);
              window.location.reload();
              navigate("/dashboard");
            } else {
              alert(`${response.error}`);
            }
          }}
        /> */}
        <Select
          className="flex items-center cursor-pointer mr-4"
          value={userData.loginAs}
          data={userData.role.map((role) => ({
            value: role.role,
            label: mapRoleToLabel(role.role),
          }))}
          // data={userData.role.split(",")}
          onChange={async (val) => {
            const response = await changeUserRole({ userRole: val });
            if (response.success) {
              const user = { ...response.user };
              setCookiesSession("userData", JSON.stringify(user));
              setCookiesSession("token", response.token);
              window.location.reload();
              navigate("/dashboard");
            } else {
              alert(`${response.error}`);
            }
          }}
        />
        {/* {userData.departments.length > 0 &&
        <Select
          className="flex items-center cursor-pointer mr-4"
          value={userData.activeDepartment}
          data={userData.departments.split(",").map((department) => ({
            value: parseInt(department),
            label: getDepartmentText(parseInt(department)),
          }))}
          onChange={async (val) => {
            const response = await changeDepartment({ department: val });
            if (response.success) {
              const user = { ...response.user };
              localStorage.setItem("userData", JSON.stringify(user));
              localStorage.setItem("token", response.token);
              window.location.reload();
              navigate("/dashboard");
            } else {
              alert(`${response.error}`);
            }
          }}
        />} */}
        <Menu>
          <Menu.Target>
            <div
              onClick={() => {
                setOpened(!opened);
              }}
              className="flex items-center cursor-pointer"
            >
              {userData.picture?.length ? (
                <Avatar size="md" src={userData.picture} radius="xl" />
              ) : (
                <Avatar size="md" radius="xl">
                  {userData.name[0].toUpperCase()}
                </Avatar>
              )}
              <div className="ml-2 flex flex-col">
                <Text size="md">{userData.name}</Text>
                <Text size="xs">{userData.email}</Text>
              </div>
            </div>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item
              onClick={() =>
                window.open(process.env.REACT_APP_LANDING_URL, "_blank")
              }
              icon={<IconExchange size={14} />}
            >
              choose manager
            </Menu.Item>
            <Menu.Item
              onClick={logoutHandler}
              icon={<IconDoorExit size={14} />}
            >
              Logout
            </Menu.Item>
            <Menu.Item></Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </div>
    </div>
  );
};

export default AppHeader;
